import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'NOTIFICATION_CENTER';

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(
    `${domain}/FETCH`,
    () => ({}),
    response => ({response}),
);

export const {
    action: fetchMore,
    success: fetchMoreSuccess,
    failed: fetchMoreFailed,
} = createAction(
    `${domain}/FETCH_MORE`,
    offset => ({offset}),
    response => ({response}),
);

export const {
    action: markAllNotificationsAsSeen,
    success: markAllNotificationsAsSeenSuccess,
    failed: markAllNotificationsAsSeenFailed,
} = createAction(`${domain}/MARK_ALL_NOTIFICATIONS_AS_SEEN`);

export const {
    action: markNotificationAsRead,
    success: markNotificationAsReadSuccess,
    failed: markNotificationAsReadFailed,
} = createAction(`${domain}/MARK_NOTIFICATION_AS_READ`, notificationId => ({notificationId}));
